import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { ICom0102PState, IDeptItemsState, IDeptCdState, IDeptStCdState } from '../../models/com/com0102p_model';

const initialState: ICom0102PState = {
    newDeptItems: {
        deptCd      : '',   // 부서코드
        upperDeptCd : '',   // 상위부서코드
        deptNm      : '',   // 부서명
        deptStCd    : '',   // 부서상태코드
    },

    deptCdList: [],     // 부서코드
    deptStCdList: [],   // 부서상태코드
}

export const com0102p_Slice = createSlice({
    name: "com0102p_Slice",
    initialState: initialState,
    reducers: {
        // initState: (state) => {
        //     Object.assign(state, {...initialState
        //         , deptCdList: state.deptCdList
        //         , deptStCdList: state.deptStCdList});
        // },
        initState: (state) => {
            Object.assign(state, {
                ...initialState,
                newDeptItems: { ...initialState.newDeptItems }  // newDeptItems를 초기화
                        , deptCdList: state.deptCdList
                        , deptStCdList: state.deptStCdList
            });
        },
        setDeptItems: (state, action:PayloadAction<IDeptItemsState>) => {
            state.newDeptItems = action.payload;
        },
        setDeptCdList: (state, action:PayloadAction<IDeptCdState[]>) => {
            state.deptCdList = action.payload;
        },
        setDeptStCdList: (state, action:PayloadAction<IDeptStCdState[]>) => {
            state.deptStCdList = action.payload;
        },
    },
});

export default com0102p_Slice.reducer;
export const Com0102pAction  = com0102p_Slice.actions;
export const Com0102pReducer = com0102p_Slice.reducer;